import { useState } from "react";

const PopupChatbot = () => {
  const [showPopup, setShowPopup] = useState(false);
  const togglePopup = () => setShowPopup((prev) => !prev);
  const closePopup = () => setShowPopup(false);

  return (
    <div>
      {!showPopup && (
        <button
          onClick={togglePopup}
          style={{
            position: "fixed",
            bottom: "2rem",
            right: "2rem",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            backgroundColor: "#7242EA",
            color: "white",
            fontSize: "1.5rem",
            border: "none",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            zIndex: 1000,
          }}
        >
          🌐
        </button>
      )}

      <div
        onClick={closePopup}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: showPopup ? "rgba(0, 0, 0, 0.3)" : "transparent",
          pointerEvents: showPopup ? "auto" : "none",
          transition: "background-color 0.3s ease",
          zIndex: 999,
        }}
      >
        <div
          style={{
            position: "fixed",
            bottom: 0,
            right: 20,
            width: "500px",
            height: "628px",
            backgroundColor: "#fff",
            border: "2px solid #7242EA",
            borderBottom: "none",
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
            boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
            zIndex: 999,
            overflow: "hidden",
            transform: showPopup ? "translateY(0)" : "translateY(100%)",
            transition: "transform 0.4s ease",
          }}
        >
          <iframe
            src="http://211.61.18.17:3000" // 원하는 사이트 주소로 변경하세요
            title="External Site"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default PopupChatbot;
